import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Estimativa } from 'src/app/models/estimativa.model';
import { AnexoService } from 'src/app/services/anexo.service';
import { EstimativaService } from 'src/app/services/estimativa.service';

@Component({
    selector: 'app-anexo-modal-component',
    templateUrl: './anexo.modal.component.html',
    styleUrls: ['./anexo-modal.component.scss']
})

export class AnexoModalComponent implements OnInit {
    basicForm: UntypedFormGroup;
    titulo: string;
    botaoCaption: string;
    selectedFile: File = null;
    estimativa: Estimativa;

    constructor(
        public dialogRef: MatDialogRef<AnexoModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private anexoService: AnexoService,
        private estimativaService: EstimativaService,
        private router: Router,
        private toastr: ToastrComponent) {
        this.createForm();
    }

    ngOnInit() {
        this.estimativaService.getById(this.data.estimativaId).subscribe(estimativa => {
            this.estimativa = estimativa;
        });
    }

    createForm() {
        this.basicForm = this.fb.group({
            arquivo: new UntypedFormControl(null)
        });

        this.titulo = this.data.titulo;
        this.botaoCaption = this.data.botaoCaption;
    }

    onSelectFile(fileInput: any) {
        this.selectedFile = fileInput.target.files[0] as File;
    }

    upload() {

        let file: string[];
        file = this.selectedFile.name.split('.');

        if (file[1] !== 'ppt' && file[1] !== 'pptx' && this.data.acao === 'aprovar') {
            this.toastr.mostrarMensagem('aviso', 'Atenção', 'Formato de arquivo inválido: ' + file[1]);
            return;
        }

        const formData = new FormData();
        formData.append('Arquivo', this.selectedFile);
        formData.append('EstimativaId', this.data.estimativaId);
        formData.append('Tipo', this.data.tipo);

        this.anexoService.upload(formData).subscribe(result => {
            if (result.mensagem.indexOf('sucesso') !== -1) {
                if (this.data.acao === 'aprovar') {
                    this.estimativa.statusId = 4;
                    this.estimativaService.update(this.estimativa).subscribe(() => {
                        this.dialogRef.close();
                        this.toastr.mostrarMensagem('sucesso', 'Sucesso', result.mensagem);
                        this.router.navigate(['price/projeto/estimativa-list/' + this.data.projetoId]);
                    });
                } else {
                    this.dialogRef.close();
                    this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Upload realizado com sucesso');
                }
            } else {
                this.toastr.mostrarMensagem('aviso', 'Atenção', result.mensagem);
            }

        }, (e) => {
            this.toastr.mostrarMensagem('erro', 'Erro', e.error.text);
        });
    }
}
